export default {
  state: {
    visibility: false,
    mode: '',
    item: '',
    temp_details: {},
    event_id: null,
    quiz_id: null
  },
  mutations: {
    INIT_EVENT_NAMING_DIALOG(state, payload) {
      state.visibility = true
      state.mode = payload.mode
      state.item = payload.item
      state.temp_details = payload.temp_details
      state.event_id = payload.event_id
      state.quiz_id = payload.quiz_id
    },
    RESET_EVENT_NAMING_DIALOG(state) {
      state.visibility = false
      state.mode = ''
      state.item = ''
      state.temp_details = {}
      state.event_id = null
      state.quiz_id = null
    }
  }
}
